export default __webpack_public_path__ + "static/media/key-vertical-unlocked.e991fc23.svg";